import React, { useMemo } from 'react';
import KkpBriefAttachmentsViewer from './KkpBriefAttachmentsViewer';
import KkpCreaPubAttachmentsEditor from './KkpCreaPubAttachmentsEditor';
import kkpService from '../../services/kkpService';
import { canEditCreaPubFichiers } from '../../utils/kkpBatValide';
import { AppAlert, AppButton, AppModal } from '../ui';
import '../../styles/kkp-pub-graphiste.scss';

const KkpCreaPubFichiersModal = ({
  show,
  vente = null,
  onClose,
  onError,
  onChange,
}) => {
  const canEdit = canEditCreaPubFichiers();
  const piecesJointes = useMemo(
    () => vente?.crea_pub_pieces_jointes ?? [],
    [vente],
  );

  if (!show || !vente) return null;

  return (
    <AppModal
      show
      size="lg"
      centered
      onClose={onClose}
      title={(
        <>
          Créations déposées — {vente.client_label}
          <span className="badge kkp-pub-graphiste-canal-badge ms-2">{vente.canal_label}</span>
        </>
      )}
      footer={<AppButton variant="outline-secondary" onClick={onClose}>Fermer</AppButton>}
    >
      <dl className="row g-2 mb-3 kkp-pub-graphiste-brief-meta">
        <div className="col-sm-6">
          <dt className="text-secondary-light">Format</dt>
          <dd className="mb-0">{vente.format || '—'}</dd>
        </div>
        <div className="col-sm-6">
          <dt className="text-secondary-light">Contenu</dt>
          <dd className="mb-0">{vente.contenu || '—'}</dd>
        </div>
        <div className="col-sm-6">
          <dt className="text-secondary-light">Période</dt>
          <dd className="mb-0">{vente.periode_label || '—'}</dd>
        </div>
        <div className="col-sm-6">
          <dt className="text-secondary-light">Terminée le</dt>
          <dd className="mb-0">{vente.pub_graphiste_terminee_at_label || '—'}</dd>
        </div>
      </dl>

      {canEdit ? (
        <KkpCreaPubAttachmentsEditor
          venteId={vente.id}
          piecesJointes={piecesJointes}
          onError={onError}
          onChange={onChange}
        />
      ) : piecesJointes.length === 0 ? (
        <AppAlert variant="warning" className="mb-0">
          Aucune création déposée pour cette publicité.
        </AppAlert>
      ) : (
        <KkpBriefAttachmentsViewer
          venteId={vente.id}
          piecesJointes={piecesJointes}
          onError={onError}
          fetchBlob={(fileId, opts) => kkpService.fetchCreaPubFichierBlob(vente.id, fileId, opts)}
          downloadFile={(fileId, filename) => kkpService.downloadCreaPubFichier(vente.id, fileId, filename)}
          title="Créations déposées"
        />
      )}
    </AppModal>
  );
};

export default KkpCreaPubFichiersModal;
